import * as React from "react";
import type { SVGProps } from "react";
const SvgClockWithArrowClockwise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.58 16.03a1 1 0 0 1-.93-.63 9 9 0 0 1 15.38-9.08V4.03a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 1 1 0-2h2.78a7 7 0 0 0-12.3 6.63 1 1 0 0 1-.93 1.37M7.2 19.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M10.323 20.677a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414M15.14 20.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M17.703 17.577a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414M20.03 14.03a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    />
    <path
      fill="currentColor"
      d="M13.37 15.78a1 1 0 0 0 .66.25 1 1 0 0 0 1.007-1.064 1 1 0 0 0-.337-.686l-1.67-1.47V7.75a1 1 0 0 0-2 0v5.52a1 1 0 0 0 .34.75z"
    />
  </svg>
);
export default SvgClockWithArrowClockwise;
